import { Component } from "react";
import { View } from "react-native";

export class ScrollViewSpacer extends Component {
    render() {
        return (
            <View style={{paddingBottom: 200}}/>
        )
    }
}